import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export const TopBar = () => {
  const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language?.toUpperCase().slice(0, 2) || 'FI');
  
  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang.toLowerCase());
    setCurrentLang(lang);
  };
  
  const helsinkiWd = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Helsinki', weekday: 'short' }).format(new Date());
  const dayOfWeek = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[helsinkiWd];
  const hours = { 1: '11:00 - 21:00', 2: '11:00 - 21:00', 3: '11:00 - 21:00', 4: '11:00 - 21:00', 5: '11:00 - 22:00', 6: '12:00 - 22:00', 0: '12:00 - 20:00' };
  const todayHours = hours[dayOfWeek];
  const dayNames = [t('days.sun'), t('days.mon'), t('days.tue'), t('days.wed'), t('days.thu'), t('days.fri'), t('days.sat')];
  const dayName = dayNames[dayOfWeek];
  const isSunday = dayOfWeek === 0;

  return (
    <motion.div 
      className="fixed top-0 left-0 right-0 z-[10000] bg-[#2F2F2F] text-white"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="max-w-[1800px] mx-auto px-4 md:px-8 flex items-center justify-between h-8 md:h-9 text-[10px] md:text-xs">
        <motion.div className="flex items-center gap-2" initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.3, duration: 0.5 }}>
          <motion.span className="text-[#C97A2B]" animate={{ scale: [1, 1.2, 1] }} transition={{ duration: 2, repeat: Infinity }}>●</motion.span>
          <span className="hidden sm:inline">{t('topBar.openToday')}:</span>
          <span className="font-medium">{dayName} {todayHours}</span>
          {isSunday && <span className="text-[#C97A2B] hidden md:inline">(À la carte)</span>}
        </motion.div>

        <motion.a href="tel:0403779200" className="flex items-center gap-2 hover:text-[#C97A2B] transition-colors"
          initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.35, duration: 0.5 }} whileHover={{ scale: 1.05 }} data-testid="topbar-phone">
          <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
          <span className="font-medium">040 377 9200</span>
        </motion.a>
        
        <motion.div className="flex items-center gap-1 md:gap-2" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.3, duration: 0.5 }}>
          {['FI', 'SV', 'EN'].map((lang, index) => (
            <motion.button key={lang} onClick={() => handleLanguageChange(lang)}
              className={`px-2 py-1 rounded transition-colors ${currentLang === lang ? 'bg-[#C97A2B] text-black font-medium' : 'hover:bg-white/10'}`}
              initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 + index * 0.1 }}
              whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }} data-testid={`lang-btn-${lang.toLowerCase()}`}>
              {lang}
            </motion.button>
          ))}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default TopBar;
